module.exports = __webpack_public_path__ + "img/D0017.08f9d5a6.svg";